"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className, compact, wrapping) {
    return {
        root: styling_1.mergeStyles("listing-list", className, styles.root, compact && styles.compactRoot, wrapping && styles.wrappingRoot)
    };
});
exports.getClassNames = getClassNames;
